<template>
	<div class="bg-white px-3 index" style="margin: 0 26px;margin-bottom: 0!important;">
		<div class="add_tits" ref="titles">
			<el-form class="form-inlines u-f u-jsb" :inline="true">
				<div>
					<el-form-item label="模糊搜索">
						<el-select v-model="cyy_lb_value" placeholder="请选择" size="small" filterable clearable>
							<el-option v-for="item in  lb_options" :key="item.id" :label="item.name" :value="item.id">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item>
						<el-button type="primary" icon="el-icon-search" size="small" @click="begin">搜索</el-button>
					</el-form-item>
				</div>
				<div>
					<el-form-item>
						<!-- <el-button type="primary" icon="el-icon-circle-plus-outline" size="small" @click="AddGroup">新增类别
						</el-button> -->
						<el-button type="primary" icon="el-icon-circle-plus-outline" size="small" @click="handleAdd">新增
						</el-button>
					</el-form-item>
				</div>
			</el-form>
		</div>
		<div class="ibox-content">
			<el-table :data="tableData" border v-loading="loading" :height="height" class="tableLimit">
				<el-table-column prop="id" label="编号"></el-table-column>
				<el-table-column prop="title" label="标题" show-overflow-tooltip></el-table-column>
				<el-table-column prop="create_time" label="添加时间" show-overflow-tooltip></el-table-column>
				<el-table-column label="操作" width="200" align="center">
					<template slot-scope="scope">
						<el-button size="mini" type="primary" icon="el-icon-edit-outline"
							@click="handleEdit(scope.row,scope.$index)"></el-button>
						<el-button size="mini" type="danger" icon="el-icon-delete"
							@click="handleDelet(scope.row,scope.$index)"></el-button>
					</template>
				</el-table-column>
			</el-table>
			<div class="u-f u-ac u-jsb ft_mr">
				<div></div>
				<div>
					<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
						:current-page="currentPage" :page-sizes="[15, 30, 50, 100]" :page-size="pagesize"
						layout="total, sizes, prev, pager, next, jumper" :total="count">
					</el-pagination>
				</div>
			</div>
		</div>
		<el-dialog title="常用语设置" :visible.sync="dialogVisible" center top="20px" width="70%" class="dialogs">
			<el-divider></el-divider>
			<div class="dialog-ibox-content">
				<el-form :model="ruleForm" :rules="rule" ref="ruleForm" label-width="150px"
					class="demo-ruleForm forms-lines">
					<el-form-item label="类别" prop='cyy_lb_value'>
						<el-select v-model="ruleForm.cyy_lb_value" placeholder="请选择" size="small" filterable>
							<el-option v-for="item in  lb_options" :key="item.id" :label="item.name" :value="item.id">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="常用语标题" prop='cyy_title'>
						<el-input v-model="ruleForm.cyy_title" size="small"></el-input>
					</el-form-item>
					<el-form-item label="常用语内容" prop='cyy_content'>
						<tinymce ref="editor" v-model="ruleForm.cyy_content"
							toolbar="undo redo |  formatselect | bold italic  | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent  | removeformat | imageUpload" />
					</el-form-item>
				</el-form>
			</div>
			<el-divider></el-divider>
			<span slot="footer" class="dialog-footer">
				<el-button @click="submit('ruleForm')" size="small" type="primary" :loading="subloading">提 交</el-button>
				<el-button @click="dialogVisible = false" size="small">取 消</el-button>
			</span>
		</el-dialog>
		<el-dialog title="类别添加" :visible.sync="groupdialogVisible" center top="150px" width="30%" class="dialogs">
			<el-divider></el-divider>
			<div class="dialog-ibox-content">
				<el-form :model="groupform" :rules="rule" ref="groupform" label-width="150px"
					class="demo-ruleForm forms-lines">

					<el-form-item label="类别名称" prop='lb_title'>
						<el-input v-model="groupform.lb_title" size="small"></el-input>
					</el-form-item>

				</el-form>
			</div>
			<el-divider></el-divider>
			<span slot="footer" class="dialog-footer">
				<el-button @click="addgroup('groupform')" size="small" type="primary" :loading="subloading">提 交
				</el-button>
				<el-button @click="groupdialogVisible = false" size="small">取 消</el-button>
			</span>
		</el-dialog>
	</div>
</template>


<script>
	import {
		mapState
	} from 'vuex'
	import tinymce from '@/components/common/tinymce.vue';
	import comment from '@/components/header/comment.vue';
	export default {
		components: {
			tinymce,
			comment
		},
		data() {
			return {
				cyy_lb_value: '',
				lb_options: [],
				loading: false,
				tableData: [],
				count: 0,
				currentPage: 1,
				pagesize: 15,
				height: null,
				// 
				eid: '0',
				dialogVisible: false,
				subloading: false,

				ruleForm: {
					cyy_title: '',
					cyy_lb_value: '',
					cyy_content: '',


				},
				groupform: {
					lb_title: '',
				},
				mapListed: [],
				state_options: [],
				ry_options: [],
				rule: {
					cyy_lb_value: [{
						required: true,
						message: '请填写图文类别',
						trigger: 'blur'
					}],
					cyy_title: [{
						required: true,
						message: '请填写图文标题',
						trigger: 'blur'
					}],

					cyy_content: [{
						required: true,
						message: '请填写图文内容',
						trigger: 'blur'
					}],
					lb_title: [{
						required: true,
						message: '请填写名称',
						trigger: 'blur'
					}],

				},
				// 
				urls: '',
				// 
				commany: 1,
				groupdialogVisible: false,
			};
		},
		computed: {
			...mapState({
				user: state => state.user.user,
			})
		},
		mounted() {
			let that = this
			that.getHeight()
			that.getlbxx()
			that.begin()
		},
		methods: {
			getHeight() {
				let that = this
				var titles = that.$refs.titles.offsetHeight
				that.height = window.innerHeight - titles - 200 + 'px'
				window.onresize = () => {
					var titles = that.$refs.titles.offsetHeight
					that.height = window.innerHeight - titles - 200 + 'px'
				}
			},
			// 搜索
			begin() {
				let that = this
				that.currentPage = 1
				that.pagesize = 15
				that.search()
			},
			search() {
				let that = this
				that.tableData = []
				that.loading = true
				axios.post("/admin/pc/consult/content/content_list", {
						page: that.currentPage,
						limit: that.pagesize,
						group_id: this.cyy_lb_value,
					}, {
						token: true
					})
					.then(response => {
						that.loading = false
						that.tableData = response.data.data.data
						that.count = response.data.data.count
					})
					.catch(error => {})
			},
			handleSizeChange(val) {
				let that = this
				that.pagesize = val;
				that.search()
			},
			handleCurrentChange(val) {
				let that = this
				that.currentPage = val;
				that.search()
			},
			handleAdd() {
				let that = this
				that.dialogVisible = true
				that.eid = '0'
				that.form_clear()
			},
			AddGroup() {
				this.groupdialogVisible = true
			},
			form_clear() {
				let that = this
				that.ruleForm.cyy_title = ''
				that.ruleForm.cyy_lb_value = ''
				that.ruleForm.cyy_content = ''


			},

			submit(formName) {
				let that = this

				that.$refs[formName].validate((valid) => {
					if (valid) {

						that.subloading = true
						let urls = "/admin/pc/consult/content/content_edit"
						axios.post(urls, {
								id: that.eid,
								group_id: that.ruleForm.cyy_lb_value,
								title: that.ruleForm.cyy_title,
								body: that.ruleForm.cyy_content,

							}, {
								token: true
							})
							.then(response => {
								that.subloading = false
								if (response.data.code == '200') {
									that.dialogVisible = false
									that.search()
								} else {
									that.$message.error(response.data.msg);
								}
							})
							.catch(error => {
								that.subloading = true
							})
					} else {
						this.$alert("信息遗漏未填")
						return false;
					}
				});
			},
			addgroup(formName) {
				let that = this

				that.$refs[formName].validate((valid) => {
					if (valid) {

						that.subloading = true
						let urls = "/admin/pc/consult/content/content_edit"
						axios.post(urls, {
								title: that.groupform.lb_title,
							}, {
								token: true
							})
							.then(response => {
								that.subloading = false
								if (response.data.code == '200') {
									that.groupdialogVisible = false
									that.search()
								} else {
									that.$message.error(response.data.msg);
								}
							})
							.catch(error => {
								that.subloading = true
							})
					} else {
						this.$alert("信息遗漏未填")
						return false;
					}
				});
			},
			// 编辑
			handleEdit(row, index) {
				let that = this
				that.form_clear()
				that.dialogVisible = true
				that.eid = row.id
				that.ruleForm.cyy_lb_value = row.group_id
				that.ruleForm.cyy_title = row.title
				that.ruleForm.cyy_content = row.body

			},
			// 删除
			handleDelet(row, index) {
				let that = this
				this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					axios
						.post("/admin/pc/consult/content/content_del", {
							id: row.id,
						}, {
							token: true
						})
						.then(response => {
							if (response.data.code == '200') {
								this.$message({
									type: 'success',
									message: '删除成功!'
								});
								that.search()
							} else {
								that.$message.error(response.data.msg);
							}
						})
						.catch(error => {})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});
			},
			gettimes() {
				let nowDate = new Date();
				let year = nowDate.getFullYear();
				let month = nowDate.getMonth() + 1;
				let day = nowDate.getDate();
				let hour = nowDate.getHours(); //获取系统时，
				let min = nowDate.getMinutes(); //分
				let sec = nowDate.getSeconds(); //秒
				month = month > 9 ? month : '0' + month
				day = day > 9 ? day : '0' + day
				hour = hour > 9 ? hour : '0' + hour
				min = min > 9 ? min : '0' + min
				sec = sec > 9 ? sec : '0' + sec
				return `${year}-${month}-${day} ${hour}:${min}`;
			},
			// 类别
			getlbxx() {
				let that = this
				axios
					.post("/admin/pc/consult/content/group_list", {}, {
						token: true
					})
					.then(response => {
						that.lb_options = response.data.data.data
					})
					.catch(error => {})
			},

		},

	};
</script>


<style scoped>
	.index {
		border-radius: 6px;
		padding-bottom: 10px;
	}

	.tablimg {
		margin: 2px 5px;
	}
</style>